function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5813 11.485L1.58105 11.4853L0.000174522 9.9044L7.90457 2L9.48545 3.58088L4.43554 8.63079L14.9321 8.63079V10.6308L3.88881 10.6308L9.48577 16.2277L7.90489 17.8086L1.5813 11.485Z",
  fill: "#6C8936"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.3508 11.485L62.3511 11.4853L63.932 9.9044L56.0276 2L54.4467 3.58088L59.4966 8.63079L49 8.63079V10.6308L60.0433 10.6308L54.4464 16.2277L56.0272 17.8086L62.3508 11.485Z",
  fill: "#6C8936"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18 19H46V35C46 42.732 39.732 49 32 49C24.268 49 18 42.732 18 35V19Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30 19V1H32.5C39.4036 1 45 6.59644 45 13.5V19H30Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.75 19.5V2H30.5C23.5964 2 18 7.59644 18 14.5V19.5H31.75Z",
  fill: "#6C8936"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 18.2313,
  y: 1.23125,
  width: 27.5375,
  height: 47.5375,
  rx: 13.7688,
  stroke: "#6C8936",
  strokeWidth: 2.4625
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.25 18.75H32M45.75 18.75H32M32 1.25V18.75",
  stroke: "#6C8936",
  strokeWidth: 2.4625
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M32 2.5V11M32 18.5H19.5",
  stroke: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 29.4813,
  y: 11.2313,
  width: 5.0375,
  height: 10.0375,
  rx: 2.51875,
  fill: "white",
  stroke: "#6C8936",
  strokeWidth: 2.4625
});

function SvgMouseControlExplore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 50,
    viewBox: "0 0 64 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseControlExplore);
export default __webpack_public_path__ + "static/media/mouse-control-explore.f2803438.svg";
export { ForwardRef as ReactComponent };